// @ts-nocheck
import { AdminTemplate, MerchantLimitFilter } from "../../components"

export const MerchantLimit = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: 'İşyeri Limit Ayarları',
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: false
            }}>
            <MerchantLimitFilter />
        </AdminTemplate>
    )
}